<template>
    <div>
      <div class="col-md-12 text-center">
        <div>
          <!-- <img class="gifimg" :src="downloadUrl + '/images/tenor.gif'" /> -->
          <img class="" src="img/svg-icons/congratulation.svg" />
        </div>
        <div>
          <h2 class="fw-bold">Course Passed</h2>
        </div>
      </div>
      <div class="col-md-12 mt-3 mb-5">
        <h3
          style="color: #444C57;"
          class=" text-center"
          v-if="pass_message === ''"
        >
          You have passed this course!
        </h3>
        <h3 style="color: #444C57;" class=" text-center" v-else>
          {{ pass_message }}
        </h3>
      </div>
  
      <div
        class="col-md-12 text-center mb-4 "
        v-if="!practice_test && certificate_availbility"
      >
        
        
        
      </div>
  
      
      <div class="btn-sticky-area  text-center">
        <a 
  href="https://wd5-impl.workday.com/racetrac9/d/home.htmld" 
  class="linkColor btn base-button w-100 lesson-btn btn-primary">
  Back to dashboard
</a>

      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  export default {
    name: "congratualtions-sectionmob",
    props: {
      practice_test: Number,
      pass_message: String,
      next_course_message: String,
      certificate_availbility: Number,
      its_super_admin: Boolean,
      hot_user: String
    },
    data() {
      return {
        baseUrl: this.$baseUrl,
        downloadUrl: this.$downloadUrl
      };
    },
    created() {},
    methods: {
      onCertificateClick() {
        // call the Flutter handler
        window.flutter_inappwebview?.callHandler('goCertificate');
        // if you *also* want Vue to route inside the webview, remove the `.prevent` modifier
        // and/or uncomment the <router-link>'s :to prop.
      },
      onDashboardClick() {
        window.flutter_inappwebview?.callHandler('goDashboard');
      },
    }
  };
  </script>
  <style scoped>
  h1 {
    transform-origin: 50% 50%;
    font-size: 50px;
    /* font-family: "Sigmar One", cursive; */
    cursor: pointer;
    z-index: 2;
    top: 0;
    text-align: center;
    width: 100%;
  }
  .lesson-btn{
      background: linear-gradient(135deg, #e4973a 0%, #eb1a26 100%);
      color: #fff;
      padding-top: 13px;
      padding-bottom: 13px;
  }
  .btn-sticky-area {
      position: fixed;
      bottom: 0;
      left: 0;
      padding: 24px;
      width: 100%;
  }
  h2 {
    font-size: 26px;
  }
  .blob {
    height: 50px;
    width: 50px;
    color: #ffcc00;
    position: absolute;
    top: 45%;
    left: 45%;
    z-index: 1;
    font-size: 30px;
    display: none;
  }
  .gifimg {
    opacity: 0.5;
    width: 26%;
  }
  
  </style>
  